var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.items,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [(item.to)?_c('v-breadcrumbs-item',{attrs:{"to":item.to,"link":true}},[_vm._v(" "+_vm._s(item.text)+" ")]):_c('v-breadcrumbs-item',{attrs:{"disabled":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }